/**
 * @generated SignedSource<<0aabb650392176f5f97d5b5b89f3ace3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type PGAnalyzeIntegrationDeleteMutation$variables = {
  input: DeleteIntegrationInput;
};
export type PGAnalyzeIntegrationDeleteMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PGAnalyzeIntegrationDeleteMutation = {
  response: PGAnalyzeIntegrationDeleteMutation$data;
  variables: PGAnalyzeIntegrationDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAnalyzeIntegrationDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAnalyzeIntegrationDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7c0c4b4df6ab8e6661cb6535cd198fd",
    "id": null,
    "metadata": {},
    "name": "PGAnalyzeIntegrationDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PGAnalyzeIntegrationDeleteMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9686b40b1f88373f609bc6250fed2081";

export default node;
